
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCompanySet, modifyCompany, modifyCompanySet, getDiyEorder, getRepairPrompt, setRepairPrompt } from '@/api/system';
import { UserModule } from '../../store/modules/user';
import { checkPermissionCompany } from '@/utils/permission';
import { makeKey } from '@/utils/qiniu';

// [AMapReplace->OrderArea 20260825] 原地图选点组件 PickAddressInMap 替换为 OrderArea 省市区选择器
import OrderArea from '@/views/order/components/OrderArea.vue';
import dialogSetStaff from '@/components/StaffDialog/index.vue';
import { Type } from '../../types/permissionType';
import draggable from 'vuedraggable';
import { configDingding, configWechat, getDingdingConfig, getWechatConfig } from '@/api/templateEvaluate';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import pushSeting from '@/views/system/SettingPush.vue';
import sparePartsSetting from '@/views/system/SettingSpareParts.vue';
import wxGZHImg from '@/assets/images/wxGZH-1.png';
import wxGZHImg2 from '@/assets/images/wxGZH-2.png';
import { SettingsModule } from '@/store/modules/settings'
import { getUserInfo } from '@/api/users';

@Component({
  name: 'SystemSettingBase',
  components: {
    OrderArea,
    dialogSetStaff,
    draggable,
    dialogImgLarge,
    pushSeting,
    sparePartsSetting
  }
})
export default class extends Vue {
  private activeName = 'company'
  private officialActive = 'push'
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private companyForm:any = {};
  private isShowWX=false;
  private isShowGZH=false;
  private isShowWorkNum=false;
  private wxGZHUrl=''

  private defaultImgUrl = 'this.src="' + require('@/assets/images/default-avatar.png') + '"'
  private defaultLogo = require('@/assets/images/logo.png');
  private wechatCode = require('@/assets/images/code-weixin.png')
  private showPreview = false
  private showPreviewOfficial = false
  private showPreviewOfficialFollow = false
  private windowHg = window.innerHeight - 95;

  private uniqueForm:any = {
    logo: '',
    app_name: '',
    is_check_mobile: '',
    is_open_order_limit: '',
    customer_order_number: '',
    is_show_company_contact: '',
    is_show_company_customer: '',
    scan_qr_servicer_show: '',
    is_open_qrscan_join_inner_company: '',
    is_open_qrscan_join_inner_companydept: '',
    is_show_service_contact: '',
    is_show_engineer_contact: '',
    is_show_quote_order: '',
    is_ranking: '',
    is_open_appointment_hint: '',
    grab_order_number: '',
    is_location: '',
    orderTimeout: '',
    orderTimeout_remind_hours: '',
    orderTimeout_remind_minutes: '',
    orderTimeoutAhead: '',
    orderTimeout_remind_hours_ahead: '',
    orderTimeout_remind_minutes_ahead: '',

    TaskTimeout: '',
    TaskTimeout_remind_hours: '',
    TaskTimeout_remind_minutes: '',
    TaskTimeoutAhead: '',
    TaskTimeout_remind_hours_ahead: '',
    TaskTimeout_remind_minutes_ahead: '',

    TaskFinishTimeout: '',
    TaskFinishTimeout_remind_hours: '',
    TaskFinishTimeout_remind_minutes: '',
    TaskFinishTimeoutAhead: '',
    TaskFinishTimeout_remind_hours_ahead: '',
    TaskFinishTimeout_remind_minutes_ahead: '',

    taskFinishOver: '',
    taskFinishOver_remind_hours: '',
    taskFinishOver_remind_minutes: '',
    taskFinishOverAhead: '',
    taskFinishOver_remind_hours_ahead: '',
    taskFinishOver_remind_minutes_ahead: '',

    is_order_auto_end: '',
    order_auto_end_number: '',
    trans_is_order_auto_end: '',
    trans_order_auto_end_number: '',

    video: '',
    message: '',
    is_sync_qywxdept_upatename: '',
    is_sync_qywxapp_subscrible: '',
    wx_servicer_name: '',
    wx_servicer_logo: '',
    is_repair_limit: '',
    is_inner_repair_limit: '',
    is_refuse_accept_complete: '',
    is_refuse_auto_assign: '',
    eorder_style: '',
    is_parent_customer_show: '',
    is_servicer_company_empty: '',
    is_order_check_show: '',
    is_serforcus_complete_create_eorder: '',
    eorder_start_time: '',
    eorder_end_time: '',
    is_eorder_invite_sign: '',

    pay_qr: [],

    scan_qr_prompt: '',

    create_order_duration: 30,
    is_workorder: false,

    is_custom_work_order_num: false,
    // 报修限制
    is_repair_notice: '',
    create_order_limit: '',
    // orderLimitStart: '',
    // orderLimitEnd: '',
    orderLimitTimerange: [],
    orderLimitAcross: '',
    orderLimitStartHour: '',
    orderLimitStartMinute: '',
    orderLimitEndHour: '',
    orderLimitEndMinute: '',
    accountComplete: '',
    mobileComplete:'',

    is_repair_limit_unevaluate:'',
    repair_limit_unevaluate_start_date:'',
    unevaluate_order_number:'',

    custom_service_code: '',
    custom_work_order_num_default_value: ''
  }

  private wechatForm: any = {
    image: '',
    name: '',
    isThirdParty: '',
    wxPushApp: '',
    wxPushMsg: '',
    wxAppId: '',
    wx_qr_tip: '',
    wx_url: '',
    wx_qr_img: ''
  }
  private dingdingAuth = false;

  private formatSelected:any=[]
  private customerShowFormat=[
    { name: '申请人', id: '1', show: true },
    { name: '客户', id: '4', show: false },
    { name: '部门', id: '2', show: true }]
  private orderAutoEndDate: any = [3, 7, 30, 60, 90]
  private eorderStyleList: any = [{
    label: '新版体验样式',
    value: 2
  }, {
    label: '默认常规样式',
    value: 1
  } ]
  private eorderStartTimeList:any = [{
    label: '报修时间',
    value: 1
  }, {
    label: '指派时间',
    value: 2
  }, {
    label: '任务处理',
    value: 3
  }, {
    label: '签到时间',
    value: 4
  }]
  private eorderEndTimeList: any = [{
    label: '任务完成',
    value: 1
  }, {
    label: '订单验收时间',
    value: 2
  }]
  private qrscanJoinCompanyValue = '1'
  private qrscanJoinCompanyOptions = [{
    value: '1',
    label: '加入公司'
  }, {
    value: '2',
    label: '不加入公司'
  }]

  private qrscanJoinCompanyDeptValue = '1'
  private qrscanJoinCompanyDeptOptions = [{
    value: '1',
    label: '必须加入公司部门'
  }, {
    value: '2',
    label: '可选加入公司部门'
  }]


  private hoursNormalOptions: any = []
  private hoursOptions:any=[]
  private minutesOptions:any=[]

  private saveLoading = false
  private qiniuBean:any = { token: '', key: '', default_url: '', domain: '' }

  private show:any = {}
  private showCustomEorder = false;
  private showEorder = false;

  private showAddressDialog = false

  private rules = {

  }

  private dialogSetStaffVisible = false
  private deptId = ''
  private enterType = 5

  private dialogSettingElectronicVisible = false
  private formElectronic: any = {
    name: '',
    Excel: []
  }

  // 工单号设置
  private formatWorkorder: any = [];
  private workorderShowFormat: any = [

  ]

  private checkSelect:any = []

  closeSetStaff(value: boolean) {
    this.dialogSetStaffVisible = value;
  }

  remainUserSelect(val:any) {
  }

  get isHaveTransfer(){
    return checkPermissionCompany(UserModule.getCompanyId, Type.ORDER_TRANSFER);
  }

  private isNB=false;
  created() {
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.isNB = UserModule.getCompany.vip_level.substring(0, 1) === '2'
    }
    this.isShowGZH = checkPermissionCompany(UserModule.getCompanyId, Type.GZHuth);
    this.isShowWX = checkPermissionCompany(UserModule.getCompanyId, Type.WXAuth);
    for (var h = 0; h < 24; h++) {
      this.hoursNormalOptions.push(h);
    }
    for (var m = 0; m < 241; m++) {
      this.hoursOptions.push(m);
    }
    var min = 0;
    this.minutesOptions.push(min);
    for (var i = 0; i < 11; i++) {
      min = min + 5;
      this.minutesOptions.push(min);
    }
    this.getCompanySet();
    // 公众号设置 钉钉设置
    this.dingdingAuth = checkPermissionCompany(UserModule.getCompanyId, Type.DingDingAuth);
    if (this.dingdingAuth) this.getDingdingConfig();
    this.getWechatConfig();

    // 自定义电子工单
    this.showCustomEorder = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_ELECTRONIC);
    this.showEorder = checkPermissionCompany(UserModule.getCompanyId, Type.ELECTRONIC);

    for (var j = 0; j < this.customerShowFormat.length; j++) {
      if (parseInt(this.customerShowFormat[j].id) === 4) {
        this.customerShowFormat[j].show = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
      }
    }
  }
  private changeaaaa(val:any) {
  }

  private tabBefore(activeName: any) {
    if (activeName === 'empty-1' || activeName === 'empty-2' || activeName === 'empty-3' || activeName === 'empty-4') {
      return false;
    }
  }

  private dialogOrderLimitNoticeVisible = false
  private formLimitNotice: any = {
    title: '',
    content: ''
  }
  private setNoticeType: number = 1
  private settingNotice() {
    this.setNoticeType = 1;
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.type = 1;
    getRepairPrompt(pamars).then(res => {
      if (res.data) {
        this.formLimitNotice.title = res.data.title;
        this.formLimitNotice.content = res.data.content;
      } else {
        this.formLimitNotice.title = '';
        this.formLimitNotice.content = '';
      }
    });
    this.dialogOrderLimitNoticeVisible = true;
  }
  private settingNoticeNoRepair() {
    this.setNoticeType = 2;
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.type = 2;
    getRepairPrompt(pamars).then(res => {
      if (res.data) {
        this.formLimitNotice.title = res.data.title;
        this.formLimitNotice.content = res.data.content;
      } else {
        this.formLimitNotice.title = '';
        this.formLimitNotice.content = '';
      }
    });
    this.dialogOrderLimitNoticeVisible = true;
  }
  private saveNotice() {
    if (!this.formLimitNotice.title) {
      this.showErrorMsg('请输入提示标题');
      return;
    }
    if (!this.formLimitNotice.content) {
      this.showErrorMsg('请输入提示内容');
      return;
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.type = this.setNoticeType;
    pamars.title = this.formLimitNotice.title;
    pamars.content = this.formLimitNotice.content;
    setRepairPrompt(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.dialogOrderLimitNoticeVisible = false;
    }).then((err:any) => {
      this.showErrorMsg(err.msg);
    });
  }

  /**
   * 东改 公众号设置
  */
  private getWechatConfig() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getWechatConfig(params).then(res => {
      if (res.data) {
        this.wechatForm.name = res.data.wx_servicer_name;
        this.wechatForm.image = res.data.wx_servicer_logo;
        this.wechatForm.isThirdParty = parseInt(res.data.is_third_party) === 1;
        this.wechatForm.wxPushApp = res.data.wx_push_app;
        this.wechatForm.wxPushMsg = res.data.wx_push_msg;
        this.wechatForm.wxAppId = res.data.wx_app_id;
        this.wechatForm.repair_url = res.data.repair_url;
        this.wechatForm.func_infos = res.data.func_infos;
        this.wechatForm.wx_name = res.data.wx_name;
        this.wechatForm.wx_head_img = res.data.wx_head_img;

        this.wechatForm.wx_qr_tip = res.data.wx_qr_tip;
        this.wechatForm.wx_url = res.data.wx_url;
        this.wechatForm.wx_qr_img = res.data.wx_qr_img;
      }
      // 网页
      if (res.data.func_infos.indexOf(4) >= 0) {
        let t = '';
        if (parseInt(res.data.service_type_info) !== 2 || parseInt(res.data.verify_type_info) !== 0) {
          this.wechatForm.func_infos_msg = res.data.func_infos;
          t = '，但该公众号没有群发与通知权限';
        }
        this.wechatForm.func_infos_text = '已授权' + t;
      } else {
        this.wechatForm.func_infos_text = '未授权';
      }
      // 群发
      if (res.data.func_infos.indexOf(7) >= 0) {
        let t = '';
        if (parseInt(res.data.service_type_info) !== 2 || parseInt(res.data.verify_type_info) !== 0) {
          this.wechatForm.func_infos_msg = res.data.func_infos;
          t = '，但该公众号没有群发与通知权限';
        }
        this.wechatForm.func_infos_text2 = '已授权' + t;
      } else {
        this.wechatForm.func_infos_text2 = '未授权';
      }

      // -1未认证
      // 0微信认证
      // 1新浪微博认证
      // 2腾讯微博认证
      // 3已资质认证通过但还未通过名称认证
      // 4已资质认证通过、还未通过名称认证，但通过了新浪微博认证
      // 5已资质认证通过、还未通过名称认证，但通过了腾讯微博认证
      switch (parseInt(res.data.verify_type_info)) {
        case -1:
          this.wechatForm.verify_type_info_text = '未认证';
          break;
        case 0:
          this.wechatForm.verify_type_info_text = '微信认证';
          break;
        case 1:
          this.wechatForm.verify_type_info_text = '新浪微博认证';
          break;
        case 2:
          this.wechatForm.verify_type_info_text = '腾讯微博认证';
          break;
        case 3:
          this.wechatForm.verify_type_info_text = '已资质认证通过但还未通过名称认证';
          break;
        case 4:
          this.wechatForm.verify_type_info_text = '已资质认证通过、还未通过名称认证，但通过了新浪微博认证';
          break;
        case 5:
          this.wechatForm.verify_type_info_text = '已资质认证通过、还未通过名称认证，但通过了腾讯微博认证';
          break;
        default:
          this.wechatForm.verify_type_info_text = '';
      }
    }).catch(err => {
      let msg = err.msg;
      // this.showErrorMsg(err.msg);
    });
  }
  private clickToConfigWechat() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      wx_servicer_name: this.wechatForm.name,
      wx_servicer_logo: this.wechatForm.image,
      wx_push_app: this.wechatForm.wxPushApp, // 处理模板
      wx_push_msg: this.wechatForm.wxPushMsg, // 进度模板
      wx_qr_tip: this.wechatForm.wx_qr_tip,
      wx_url: this.wechatForm.wx_url,
      wx_qr_img: this.wechatForm.wx_qr_img,
    };
    configWechat(params).then(res => {
      this.showSuccessMsg('保存成功');
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 授权公众号
  private wxGZHImg: any = wxGZHImg;
  private wxGZHImg2: any = wxGZHImg2;
  private authGongZhongHao(val:number) {
    if (val === 1) {
      window.open(this.wxGZHUrl);
    } else {
      const h = this.$createElement;
      this.$confirm('', '解除公众号授权操作步骤', {
        message: h('div', [
          h('p', { style: {
            'margin-bottom': '20px'
          } }, '请登录您司公众号按下方步骤操作 '),
          h('img', {
            attrs: {
              src: this.wxGZHImg
            },
            on: {
              click: this.imgLargeHandle1
            }
          }),
          h('img', {
            attrs: {
              src: this.wxGZHImg2
            },
            on: {
              click: this.imgLargeHandle2
            }
          })
        ]),
        confirmButtonText: '我知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning',
        customClass: 'bxgj-message-warning'
      }).then(() => {
      });
    }
  }
  // 上传图片
  private handleAvatarSuccess(val: any) {
    this.wechatForm.image = val.key;
  }

  // 推送设置
  private formPush: any = {
    number: '',
    current: ''
  }
  private formPushRecord: any = {
    start: '',
    end: '',
    mobile: '',
    sendStatus: '',
    ordernumber: ''
  }
  private optionSendStatus = [{
    value: '1',
    label: '已接通'
  }, {
    value: '2',
    label: '没人接'
  }]
  private tableDataPush: any = []
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private rechargeHandle() {
    this.$confirm('请联系报修管家010-62111361进行充值', '提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    });
  }
  private handlePageSizeChange(val: any) {

  }
  private handleCurrentChange(val: any) {

  }

  /**
   * 东改 钉钉设置
  */
  private dingForm: any = {
    corpId: '',
    agentId: '',
    appKey: '',
    appSecret: '',
    ip: '',
    address: '',
    image: '',
    name: ''
  }
  private getDingdingConfig() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getDingdingConfig(params).then(res => {
      if (res.data) {
        this.dingForm.corpId = res.data.wx_corp_id;
        this.dingForm.agentId = res.data.agent_id;
        this.dingForm.appKey = res.data.wx_key;
        this.dingForm.appSecret = res.data.wx_app_secret;
        this.dingForm.ip = res.data.dd_ip;
        this.dingForm.address = res.data.repair_url;
        this.dingForm.image = res.data.wx_servicer_logo;
        this.dingForm.name = res.data.wx_servicer_name;
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private clickToConfigDingding() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      wx_corp_id: this.dingForm.corpId,
      agent_id: this.dingForm.agentId,
      wx_key: this.dingForm.appKey, // 处理模板
      wx_app_secret: this.dingForm.appSecret, // 进度模板
      dd_ip: this.dingForm.ip,
      repair_url: this.dingForm.address,
      wx_servicer_name: this.dingForm.name,
      wx_servicer_logo: this.dingForm.image
    };
    configDingding(params).then(res => {
      this.showSuccessMsg('保存成功');
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private handleDingdingAvatarSuccess(val: any) {
    this.dingForm.image = val.key;
  }

  private eorderDiyHandle() {
    this.dialogSettingElectronicVisible = true;
  }
  private eorderSetTemplateHandle() {
    let tolink = this.$router.resolve({
      path: '/SystemTemplateSetting'
    });
    window.open(tolink.href);
  }
  private eorderDiySubmit() {

  }

  /**
   * 其他
  */
  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data) {
        if (res.data.company) {
          this.companyForm = res.data.company;
          if (res.data.company.province_name !== res.data.company.city_name) {
            this.companyForm.area = res.data.company.province_name + '  ' + res.data.company.city_name + '  ' + res.data.company.district_name;
          } else {
            this.companyForm.area = res.data.company.province_name + '  ' + res.data.company.district_name;
          }
          this.show = res.data.show;
          this.show.show_servicer = checkPermissionCompany(UserModule.getCompanyId, Type.SERVICER_MODULE);
          this.uniqueForm.video = checkPermissionCompany(UserModule.getCompanyId, Type.ORDER_VIDEO_CALL);
          this.uniqueForm.message = checkPermissionCompany(UserModule.getCompanyId, Type.ORDER_BBS_LOOK);
          this.show.polling = checkPermissionCompany(UserModule.getCompanyId, Type.EORDER_POLLING);
          this.show.show_qywx = parseInt((UserModule.getCompany as any).is_qywx) === 1;
          // 150000 判断服务方模块
          this.uniqueForm.logo = res.data.company.app_logo;
          this.qiniuBean = res.data.qiniu;
          this.uniqueForm.app_name = res.data.company.app_name;
          this.uniqueForm.is_check_mobile = parseInt(res.data.company.is_check_mobile);
          this.uniqueForm.is_location = parseInt(res.data.company.is_location) === 1;
          this.uniqueForm.is_show_company_contact = parseInt(res.data.company.is_show_company_contact) === 1;
          this.uniqueForm.is_show_service_contact = parseInt(res.data.company.is_show_service_contact) === 1;
          this.uniqueForm.is_show_engineer_contact = parseInt(res.data.company.is_show_engineer_contact) === 1;
          this.uniqueForm.is_show_quote_order = parseInt(res.data.company.is_show_quote_order) === 1;
          if (res.data.company.pay_qr) {
            this.uniqueForm.pay_qr = res.data.company.pay_qr.split(',');
          }
          this.getDiyEorder(parseInt(res.data.company.eorder_style));
          switch (parseInt(res.data.company.eorder_style)) {
            case 1:
              this.uniqueForm.eorder_style = 1;
              break;
            case 2:
              this.uniqueForm.eorder_style = 2
              break;
          }
          this.uniqueForm.is_parent_customer_show = parseInt(res.data.company.is_parent_customer_show) === 1;
          this.uniqueForm.is_servicer_company_empty = parseInt(res.data.company.is_servicer_company_empty) === 1;
          this.uniqueForm.is_order_check_show = parseInt(res.data.company.is_order_check_show) === 1;
          switch (parseInt(res.data.company.eorder_start_time)) {
            case 1:
              this.uniqueForm.eorder_start_time = 1;
              break;
            case 2:
              this.uniqueForm.eorder_start_time = 2;
              break;
            case 3:
              this.uniqueForm.eorder_start_time = 3;
              break;
            case 4:
              this.uniqueForm.eorder_start_time = 4;
              break;
          }
          switch (parseInt(res.data.company.eorder_end_time)) {
            case 1:
              this.uniqueForm.eorder_end_time = 1;
              break;
            case 2:
              this.uniqueForm.eorder_end_time = 2;
              break;
          }
        }
        if (res.data.companySet) {
          this.isShowWorkNum = parseInt(res.data.companySet.show_custom_work_order_num_setting) === 1;
          this.uniqueForm.is_open_order_limit = parseInt(res.data.companySet.is_open_order_limit) === 1;
          this.uniqueForm.customer_order_number = res.data.companySet.customer_order_number;
          this.uniqueForm.is_ranking = parseInt(res.data.companySet.is_ranking) === 1;
          this.uniqueForm.is_open_appointment_hint = parseInt(res.data.companySet.is_open_appointment_hint) === 1;
          this.uniqueForm.grab_order_number = res.data.companySet.grab_order_number;
          // 自定义工单号
          this.uniqueForm.is_custom_work_order_num = parseInt(res.data.companySet.is_custom_work_order_num) === 1;
          this.uniqueForm.custom_work_order_num_default_value = res.data.companySet.custom_work_order_num_default_value;
          this.uniqueForm.custom_service_code = res.data.companySet.custom_service_code;
          this.uniqueForm.is_set_work_order_num_default_value = res.data.companySet.is_set_work_order_num_default_value;
          // 是否启用维保订单代客验收生成电子工单
          this.uniqueForm.is_serforcus_complete_create_eorder = parseInt(res.data.companySet.is_serforcus_complete_create_eorder) === 1;
          this.uniqueForm.is_eorder_invite_sign = parseInt(res.data.companySet.is_eorder_invite_sign) === 1

          this.workorderShowFormat = res.data.companySet.custom_work_order_num_form;
          this.workorderShowFormat.forEach((element:any) => {
            if (element.is_check) {
              this.formatWorkorder.push(element.id);
            }
          });

          if (res.data.companySet.order_customer_show_format) {
            this.formatSelected = (res.data.companySet.order_customer_show_format).split(',');
          } else {
            this.formatSelected = [];
          }
          let temp = [];
          for (let i = 0; i < this.formatSelected.length; i++) {
            for (var j = 0; j < this.customerShowFormat.length; j++) {
              if (parseInt(this.customerShowFormat[j].id) === parseInt(this.formatSelected[i])) {
                temp.push(this.customerShowFormat[j]);
              }
            }
          }
          for (let i = 0; i < temp.length; i++) {
            let a = this.customerShowFormat.indexOf(temp[i]);
            this.customerShowFormat.splice(a, 1);
          }
          this.customerShowFormat = temp.concat(this.customerShowFormat);
          this.uniqueForm.orderTimeout = parseInt(res.data.companySet.is_untreated_order_timeout) === 1;
          this.uniqueForm.orderTimeout_remind_hours = res.data.companySet.timeout_remind_hours;
          this.uniqueForm.orderTimeout_remind_minutes = res.data.companySet.timeout_remind_minutes;
          this.uniqueForm.orderTimeoutAhead = parseInt(res.data.companySet.is_untreated_order_timeout_ahead) === 1;
          this.uniqueForm.orderTimeout_remind_hours_ahead = res.data.companySet.timeout_remind_hours_ahead;
          this.uniqueForm.orderTimeout_remind_minutes_ahead = res.data.companySet.timeout_remind_minutes_ahead;
          this.uniqueForm.TaskTimeout = parseInt(res.data.companySet.is_untreated_task_timeout) === 1;
          this.uniqueForm.TaskTimeout_remind_hours = res.data.companySet.untreated_task_timeout_remind_hours;
          this.uniqueForm.TaskTimeout_remind_minutes = res.data.companySet.untreated_task_timeout_remind_minutes;
          this.uniqueForm.TaskTimeoutAhead = parseInt(res.data.companySet.is_untreated_task_timeout_ahead) === 1;
          this.uniqueForm.TaskTimeout_remind_hours_ahead = res.data.companySet.untreated_task_timeout_remind_hours_ahead;
          this.uniqueForm.TaskTimeout_remind_minutes_ahead = res.data.companySet.untreated_task_timeout_remind_minutes_ahead;

          this.uniqueForm.TaskFinishTimeout = parseInt(res.data.companySet.is_unfinish_task_timeout) === 1;
          this.uniqueForm.TaskFinishTimeout_remind_hours = res.data.companySet.unfinish_task_timeout_remind_hours;
          this.uniqueForm.TaskFinishTimeout_remind_minutes = res.data.companySet.unfinish_task_timeout_remind_minutes;
          this.uniqueForm.TaskFinishTimeoutAhead = parseInt(res.data.companySet.is_unfinish_task_timeout_ahead) === 1;
          this.uniqueForm.TaskFinishTimeout_remind_hours_ahead = res.data.companySet.unfinish_task_timeout_remind_hours_ahead;
          this.uniqueForm.TaskFinishTimeout_remind_minutes_ahead = res.data.companySet.unfinish_task_timeout_remind_minutes_ahead;

          this.uniqueForm.is_order_auto_end = parseInt(res.data.companySet.is_order_auto_end) === 1;
          this.uniqueForm.order_auto_end_number = res.data.companySet.order_auto_end_number;
          this.uniqueForm.trans_is_order_auto_end = parseInt(res.data.companySet.trans_is_order_auto_end) === 1;
          this.uniqueForm.trans_order_auto_end_number = res.data.companySet.trans_order_auto_end_number;
          this.uniqueForm.wx_servicer_logo = res.data.companySet.wx_servicer_logo;
          this.uniqueForm.wx_servicer_name = res.data.companySet.wx_servicer_name;
          this.uniqueForm.is_repair_limit = parseInt(res.data.companySet.is_repair_limit) === 1;
          this.uniqueForm.is_inner_repair_limit = parseInt(res.data.companySet.is_inner_repair_limit) === 1;
          this.uniqueForm.is_sync_qywxdept_upatename = parseInt(res.data.companySet.is_sync_qywxdept_upatename) === 1;
          this.uniqueForm.is_sync_qywxapp_subscrible = parseInt(res.data.companySet.is_sync_qywxapp_subscrible) === 1;
          this.uniqueForm.is_refuse_accept_complete = parseInt(res.data.companySet.is_refuse_accept_complete) === 1;
          this.uniqueForm.is_refuse_auto_assign = parseInt(res.data.companySet.is_refuse_auto_assign) === 1;
          this.uniqueForm.scan_qr_prompt = res.data.companySet.scan_qr_prompt;
          if (res.data.companySet.create_order_duration) {
            this.uniqueForm.create_order_duration = res.data.companySet.create_order_duration;
          }
          this.uniqueForm.taskFinishOver = parseInt(res.data.companySet.is_unfinish_order_timeout) === 1;
          this.uniqueForm.taskFinishOver_remind_hours = res.data.companySet.unfinish_order_timeout_remind_hours;
          this.uniqueForm.taskFinishOver_remind_minutes = res.data.companySet.unfinish_order_timeout_remind_minutes;

          this.uniqueForm.taskFinishOverAhead = parseInt(res.data.companySet.is_unfinish_order_timeout_ahead) === 1;
          this.uniqueForm.taskFinishOver_remind_hours_ahead = res.data.companySet.unfinish_order_timeout_remind_hours_ahead;
          this.uniqueForm.taskFinishOver_remind_minutes_ahead = res.data.companySet.unfinish_order_timeout_remind_minutes_ahead;

          // 报修限制
          this.uniqueForm.accountComplete = parseInt(res.data.companySet.is_check_qywx_user_name) === 1;
          this.uniqueForm.mobileComplete = parseInt(res.data.companySet.is_check_qywx_user_mobile) === 1;
          this.uniqueForm.scan_qr_servicer_show = parseInt(res.data.companySet.scan_qr_servicer_show) === 1;
          this.uniqueForm.is_open_qrscan_join_inner_company = parseInt(res.data.companySet.is_open_qrscan_join_inner_company) !== 0;
          if (this.uniqueForm.is_open_qrscan_join_inner_company) {
            this.qrscanJoinCompanyValue = res.data.companySet.is_open_qrscan_join_inner_company
          } else {
            this.qrscanJoinCompanyValue = '1'
          }

          this.uniqueForm.is_open_qrscan_join_inner_companydept = parseInt(res.data.companySet.is_open_qrscan_join_inner_companydept) !== 0;
          if (this.uniqueForm.is_open_qrscan_join_inner_companydept) {
            this.qrscanJoinCompanyDeptValue = res.data.companySet.is_open_qrscan_join_inner_companydept
          } else {
            this.qrscanJoinCompanyDeptValue = '1'
          }

          this.uniqueForm.is_show_company_customer = parseInt(res.data.companySet.scan_qr_customer_show) === 1;
          this.uniqueForm.is_repair_notice = parseInt(res.data.companySet.is_repair_prompt) === 1;
          this.uniqueForm.create_order_limit = parseInt(res.data.companySet.is_repair_limit_time) === 1;
          if (parseInt(res.data.companySet.repair_limit_start_date) > 0) {
            this.uniqueForm.orderLimitTimerange[0] = res.data.companySet.repair_limit_start_date + '000';
          }
          if (parseInt(res.data.companySet.repair_limit_end_date) > 0) {
            this.uniqueForm.orderLimitTimerange[1] = res.data.companySet.repair_limit_end_date + '000';
          }
          this.uniqueForm.orderLimitAcross = res.data.companySet.repair_limit_is_skip_day;
          if (parseInt(res.data.companySet.repair_limit_start_time) > 0) {
            let sTH = parseInt(parseInt(res.data.companySet.repair_limit_start_time) / 3600 + '');
            this.$set(this.uniqueForm, 'orderLimitStartHour', sTH);
            let sTM = (parseInt(res.data.companySet.repair_limit_start_time) - 3600 * sTH) / 60;
            this.$set(this.uniqueForm, 'orderLimitStartMinute', sTM);
          }
          if (parseInt(res.data.companySet.repair_limit_end_time) > 0) {
            let sEH = parseInt(parseInt(res.data.companySet.repair_limit_end_time) / 3600 + '');
            this.$set(this.uniqueForm, 'orderLimitEndHour', sEH);
            let sEM = (parseInt(res.data.companySet.repair_limit_end_time) - 3600 * sEH) / 60;
            this.$set(this.uniqueForm, 'orderLimitEndMinute', sEM);
          }

          this.uniqueForm.is_repair_limit_unevaluate = parseInt(res.data.companySet.is_repair_limit_unevaluate) === 1;
          if (parseInt(res.data.companySet.repair_limit_unevaluate_start_date) > 0) {
            this.uniqueForm.repair_limit_unevaluate_start_date = res.data.companySet.repair_limit_unevaluate_start_date + '000';
          }
          this.uniqueForm.unevaluate_order_number = res.data.companySet.unevaluate_order_number;

        }
        if (res.data.wxData) {
          this.wxGZHUrl = res.data.wxData.third_auth_url;
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private areaCilck() {
    this.showAddressDialog = true;
  }
  // [AMapReplace->OrderArea 20260825] 原地图选点回调 positionPicker 改为省市区选择回调 areaSave；
  // OrderArea 仅提供省市区及 adcode，latitude/longitude/address 不再由组件回填
  private saveAreaHandle(area: any) {
    if (area) {
      this.companyForm.province_name = area.province_name;
      this.companyForm.province = area.province;
      this.companyForm.city_name = area.city_name;
      this.companyForm.city = area.city;
      this.companyForm.district_name = area.district_name;
      this.companyForm.district = area.district;
      this.companyForm.area = area.province_name + '  ' + area.city_name + '  ' + area.district_name;
    }
  }
  closeAddress() {
    this.showAddressDialog = false;
  }
  //
  private timeoutRemindChange() {

    if(!this.uniqueForm.orderTimeout){
      this.uniqueForm.orderTimeoutAhead = 0;
    }
    if(!this.uniqueForm.TaskFinishTimeout){
      this.uniqueForm.TaskFinishTimeoutAhead = 0;
    }
    if(!this.uniqueForm.taskFinishOver){
      this.uniqueForm.taskFinishOverAhead = 0;
    }
    if(!this.uniqueForm.TaskTimeout){
      this.uniqueForm.TaskTimeoutAhead = 0;
    }
  }
  private timeoutRemindAheadChange() {

  }
  private setRemindUser(type:any) {
    this.enterType = type;
    this.dialogSetStaffVisible = true;
  }

  // 保存公司信息
  private saveCompanyBtn() {
    if (!this.companyForm.name) {
      this.showErrorMsg('请输入单位名称');
      return;
    }
    if (this.companyForm.name.length < 5 || this.companyForm.name.length > 30) {
      this.showErrorMsg('请输入5～30位由字母、数字、中文、下划线、小括号（中英文）组成的公司名称');
      return;
    }
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.companyForm.name;
    params.short_name = this.companyForm.short_name;
    params.manager = this.companyForm.manager;
    params.mobile = this.companyForm.mobile;
    params.service_phone = this.companyForm.service_phone;
    params.phone_num = this.companyForm.phone_num;
    if (this.companyForm.adcode) {
      params.adcode = this.companyForm.adcode;
      params.longitude = this.companyForm.longitude;
      params.latitude = this.companyForm.latitude;
    } else {
      params.province_name = this.companyForm.province_name;
      params.province = this.companyForm.province;
      params.city_name = this.companyForm.city_name;
      params.city = this.companyForm.city;
      params.district_name = this.companyForm.district_name;
      params.district = this.companyForm.district;
    }
    params.address = this.companyForm.address;
    params.profile = this.companyForm.profile;
    params.logo = this.companyForm.logo;
    modifyCompany(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.updateInfo()
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private saveCopanySet(params:any) {
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.updateInfo()
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private async updateInfo() {
    await getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async(res:any) => {
      await UserModule.setLogin(res.data);
    });
  }
  // 保存公司设置
  private saveCompanySetBtn() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.app_logo = this.uniqueForm.logo;
    //选填 
    // if (!this.uniqueForm.app_name || this.uniqueForm.app_name.length < 1 || this.uniqueForm.app_name.length > 30) {
    //   this.showErrorMsg('请输入由1-30个数字、字母、汉字、符号组成的APP展示页名称');
    //   return;
    // }
    params.app_name = this.uniqueForm.app_name;
    // this.saveCopanySet(params);
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.updateInfo()
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // private changeCreateOrderLimit(){

    

  // }

  // 保存保修设置
  private async saveCustomerSetBtn() {
    if (this.uniqueForm.create_order_limit) {

      if (!this.uniqueForm.orderLimitTimerange[0]) {
        this.showErrorMsg('请选择开始日期');
        return;
      }
      if (!this.uniqueForm.orderLimitTimerange[1]) {
        this.showErrorMsg('请选择结束日期');
        return;
      }
      if (this.uniqueForm.orderLimitTimerange && (this.uniqueForm.orderLimitTimerange[0] > this.uniqueForm.orderLimitTimerange[1])) {
        this.showErrorMsg('结束日期不能早于开始日期');
        return;
      }
      if ((!this.uniqueForm.orderLimitStartHour && parseInt(this.uniqueForm.orderLimitStartHour) !== 0) || (!this.uniqueForm.orderLimitStartMinute && parseInt(this.uniqueForm.orderLimitStartMinute) !== 0)) {
        this.showErrorMsg('请选择开始时间');
        return;
      }
      if ((!this.uniqueForm.orderLimitEndHour && parseInt(this.uniqueForm.orderLimitEndHour) !== 0) || (!this.uniqueForm.orderLimitEndMinute && parseInt(this.uniqueForm.orderLimitEndMinute) !== 0)) {
        this.showErrorMsg('请选择结束时间');
        return;
      }
      if (parseInt(this.uniqueForm.orderLimitAcross) === 0 && this.uniqueForm.orderLimitStartHour > this.uniqueForm.orderLimitEndHour) {
        this.showErrorMsg('结束时间不能早于开始时间');
        return;
      }

      //如果要开启 需要检查提示 提示是另外一个接口 只能再请求一次
      // this.setNoticeType = 2;
      let timelimitPamars:any = {};
      timelimitPamars.company_id = UserModule.getCompanyId;
      timelimitPamars.type = 2;
      let isSetContent = false;
      const timelimitProps = await getRepairPrompt(timelimitPamars).then(res => {
        if (res.data) {
          isSetContent =  res.data.title!="" && res.data.content!=""
        }
        //检查是否有内容 
        if( this.uniqueForm.create_order_limit &&  !isSetContent){
          return false;
        }
        // this.uniqueForm.create_order_limit =  this.uniqueForm.create_order_limit ? false : true;
        return true;
      }).catch(err => {  
        // return true;
        // this.showErrorMsg("请先设置提示标题及内容再开启此功能！")
        return;
      });
      if(!timelimitProps){
        this.showErrorMsg("请先设置限制报修时间中的提示内容！");
        return ;
      }
   
    }
    if (this.uniqueForm.is_repair_limit_unevaluate) {
      if (!this.uniqueForm.repair_limit_unevaluate_start_date) {
        this.showErrorMsg('请选择开始日期');
        return;
      }
    }

    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_check_mobile = this.uniqueForm.is_check_mobile;
    params.is_open_order_limit = this.uniqueForm.is_open_order_limit ? 1 : 0;
    params.customer_order_number = this.uniqueForm.customer_order_number;
    params.is_show_company_contact = this.uniqueForm.is_show_company_contact ? 1 : 0;
    params.is_show_service_contact = this.uniqueForm.is_show_service_contact ? 1 : 0;
    params.is_show_engineer_contact = this.uniqueForm.is_show_engineer_contact ? 1 : 0;
    params.is_show_quote_order = this.uniqueForm.is_show_quote_order ? 1 : 0;
    params.is_refuse_accept_complete = this.uniqueForm.is_refuse_accept_complete ? 1 : 0;
    params.is_refuse_auto_assign = this.uniqueForm.is_refuse_auto_assign ? 1 : 0;
    params.is_repair_limit = this.uniqueForm.is_repair_limit ? 1 : 0;
    params.is_inner_repair_limit = this.uniqueForm.is_inner_repair_limit ? 1 : 0;
    params.scan_qr_prompt = this.uniqueForm.scan_qr_prompt;
    params.create_order_duration = this.uniqueForm.create_order_duration;
    params.scan_qr_customer_show = this.uniqueForm.is_show_company_customer ? 1 : 0;
    params.scan_qr_servicer_show = this.uniqueForm.scan_qr_servicer_show ? 1 : 0;
    if (this.uniqueForm.is_open_qrscan_join_inner_company) {
      params.is_open_qrscan_join_inner_company = this.qrscanJoinCompanyValue
    } else {
      params.is_open_qrscan_join_inner_company = 0
    }
    if (this.uniqueForm.is_open_qrscan_join_inner_companydept) {
      params.is_open_qrscan_join_inner_companydept = this.qrscanJoinCompanyDeptValue
    } else {
      params.is_open_qrscan_join_inner_companydept = 0
    }
    params.is_check_qywx_user_name = this.uniqueForm.accountComplete ? 1 : 0;
    params.is_check_qywx_user_mobile = this.uniqueForm.mobileComplete ? 1 : 0;

    params.is_repair_prompt = this.uniqueForm.is_repair_notice ? 1 : 0;
    params.is_repair_limit_time = this.uniqueForm.create_order_limit ? 1 : 0;

    params.repair_limit_is_skip_day = this.uniqueForm.orderLimitAcross;

    params.repair_limit_start_date = this.uniqueForm.orderLimitTimerange ? (this.uniqueForm.orderLimitTimerange[0] / 1000) : '';
    params.repair_limit_end_date = this.uniqueForm.orderLimitTimerange ? (this.uniqueForm.orderLimitTimerange[1] / 1000) : '';
    params.repair_limit_start_time = this.uniqueForm.orderLimitStartHour + ':' + this.uniqueForm.orderLimitStartMinute;
    params.repair_limit_end_time = this.uniqueForm.orderLimitEndHour + ':' + this.uniqueForm.orderLimitEndMinute;

    params.is_repair_limit_unevaluate = this.uniqueForm.is_repair_limit_unevaluate ? 1 : 0;
    params.repair_limit_unevaluate_start_date = this.uniqueForm.repair_limit_unevaluate_start_date ? (this.uniqueForm.repair_limit_unevaluate_start_date / 1000) : '';
    params.unevaluate_order_number = this.uniqueForm.unevaluate_order_number;

    this.saveCopanySet(params);
  }
  private selectBlur(e:any) {
    this.uniqueForm.order_auto_end_number = e.target.value;
  }

  private selectBlurTrans(e:any) {
    this.uniqueForm.trans_order_auto_end_number = e.target.value;
  }

  private selectBlurOrderTimeout(e:any) {
    this.uniqueForm.orderTimeout_remind_hours = e.target.value;
  }
  private selectBlurOrderTimeoutAhead(e:any) {
    this.uniqueForm.orderTimeout_remind_hours_ahead = e.target.value;
  }
  private selectBlurTaskFinishOver(e:any) {
    this.uniqueForm.taskFinishOver_remind_hours = e.target.value;
  }
  private selectBlurTaskFinishOverAhead(e:any) {
    this.uniqueForm.taskFinishOver_remind_hours_ahead = e.target.value;
  }
  private selectBlurTaskFinishTimeout(e:any) {
    this.uniqueForm.TaskFinishTimeout_remind_hours = e.target.value;
  }
  private selectBlurTaskFinishTimeoutAhead(e:any) {
    this.uniqueForm.TaskFinishTimeout_remind_hours_ahead = e.target.value;
  }
  private selectBlurTaskTimeout(e:any) {
    this.uniqueForm.TaskTimeout_remind_hours = e.target.value;
  }
  private selectBlurTaskTimeoutAhead(e:any) {
    this.uniqueForm.TaskTimeout_remind_hours_ahead = e.target.value;
  }

  private refuseChange() {
    if(!this.uniqueForm.is_refuse_accept_complete){
      this.uniqueForm.is_refuse_auto_assign = false;
    }
  }

  // 保存订单设置
  private saveOrderSetBtn() {
    if (this.uniqueForm.is_order_auto_end) {
      if (parseInt(this.uniqueForm.order_auto_end_number) < 1) {
        this.showErrorMsg('订单自动完结时间最小值为1天');
        return;
      }
    }
    if (this.uniqueForm.trans_is_order_auto_end) {
      if (parseInt(this.uniqueForm.trans_order_auto_end_number) < 1) {
        this.showErrorMsg('订单自动完结时间最小值为1天');
        return;
      }
    }
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_open_appointment_hint = this.uniqueForm.is_open_appointment_hint ? 1 : 0;
    params.is_ranking = this.uniqueForm.is_ranking ? 1 : 0;
    let orderCustomerShowFormat = '';
    for (var i = 0; i < this.customerShowFormat.length; i++) {
      for (var j = 0; j < this.formatSelected.length; j++) {
        if (parseInt(this.customerShowFormat[i].id) === parseInt(this.formatSelected[j])) {
          orderCustomerShowFormat = orderCustomerShowFormat + this.formatSelected[j] + ',';
        }
      }
    }
    params.order_customer_show_format = orderCustomerShowFormat.substring(0, orderCustomerShowFormat.length - 1);
    params.is_untreated_order_timeout = this.uniqueForm.orderTimeout ? 1 : 0;
    params.timeout_remind_hours = this.uniqueForm.orderTimeout_remind_hours;
    params.timeout_remind_minutes = this.uniqueForm.orderTimeout_remind_minutes;
    params.is_untreated_order_timeout_ahead = this.uniqueForm.orderTimeoutAhead ? 1 : 0;
    params.timeout_remind_hours_ahead = this.uniqueForm.orderTimeout_remind_hours_ahead;
    params.timeout_remind_minutes_ahead = this.uniqueForm.orderTimeout_remind_minutes_ahead;

    params.is_untreated_task_timeout = this.uniqueForm.TaskTimeout ? 1 : 0;
    params.untreated_task_timeout_remind_hours = this.uniqueForm.TaskTimeout_remind_hours;
    params.untreated_task_timeout_remind_minutes = this.uniqueForm.TaskTimeout_remind_minutes;
    params.is_untreated_task_timeout_ahead = this.uniqueForm.TaskTimeoutAhead ? 1 : 0;
    params.untreated_task_timeout_remind_hours_ahead = this.uniqueForm.TaskTimeout_remind_hours_ahead;
    params.untreated_task_timeout_remind_minutes_ahead = this.uniqueForm.TaskTimeout_remind_minutes_ahead;

    params.is_unfinish_task_timeout = this.uniqueForm.TaskFinishTimeout ? 1 : 0;
    params.unfinish_task_timeout_remind_hours = this.uniqueForm.TaskFinishTimeout_remind_hours;
    params.unfinish_task_timeout_remind_minutes = this.uniqueForm.TaskFinishTimeout_remind_minutes;
    params.is_unfinish_task_timeout_ahead = this.uniqueForm.TaskFinishTimeoutAhead ? 1 : 0;
    params.unfinish_task_timeout_remind_hours_ahead = this.uniqueForm.TaskFinishTimeout_remind_hours_ahead;
    params.unfinish_task_timeout_remind_minutes_ahead = this.uniqueForm.TaskFinishTimeout_remind_minutes_ahead;

    params.is_order_auto_end = this.uniqueForm.is_order_auto_end ? 1 : 0;
    params.order_auto_end_number = this.uniqueForm.order_auto_end_number;
    params.trans_is_order_auto_end = this.uniqueForm.trans_is_order_auto_end ? 1 : 0;
    params.trans_order_auto_end_number = this.uniqueForm.trans_order_auto_end_number;

    params.is_unfinish_order_timeout = this.uniqueForm.taskFinishOver ? 1 : 0;
    params.unfinish_order_timeout_remind_hours = this.uniqueForm.taskFinishOver_remind_hours;
    params.unfinish_order_timeout_remind_minutes = this.uniqueForm.taskFinishOver_remind_minutes;
    params.is_unfinish_order_timeout_ahead = this.uniqueForm.taskFinishOverAhead ? 1 : 0;
    params.unfinish_order_timeout_remind_hours_ahead = this.uniqueForm.taskFinishOver_remind_hours_ahead;
    params.unfinish_order_timeout_remind_minutes_ahead = this.uniqueForm.taskFinishOver_remind_minutes_ahead;
    
    this.saveCopanySet(params);
  }

  private saveWorkOrderNum() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.is_custom_work_order_num = this.uniqueForm.is_custom_work_order_num ? 1 : 0;
    params.custom_work_order_num_default_value = this.uniqueForm.custom_work_order_num_default_value;
    params.custom_service_code = this.uniqueForm.custom_service_code;

    for (let index = 0; index < this.workorderShowFormat.length; index++) {
      let id1 = this.formatWorkorder.filter((aa:any) => {
        return aa === this.workorderShowFormat[index].id;
      });
      if (id1 && id1.length > 0) {
        this.workorderShowFormat[index].is_check = true;
      } else {
        this.workorderShowFormat[index].is_check = false;
      }
      if (parseInt(this.workorderShowFormat[index].id) === 3) {
        this.workorderShowFormat[index].is_check = true;
      }
    }
    params.custom_work_order_num_form = JSON.stringify(this.workorderShowFormat);
    this.saveCopanySet(params);
  }

  // 保存工程师设置
  private saveEngSetBtn() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.grab_order_number = this.uniqueForm.grab_order_number;
    params.is_location = this.uniqueForm.is_location ? 1 : 0;
    this.saveCopanySet(params);
  }
  // 保存电子工单
  private saveEorderSetBtn() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.eorder_style = this.uniqueForm.eorder_style;
    params.is_parent_customer_show = this.uniqueForm.is_parent_customer_show ? 1 : 0;
    params.is_servicer_company_empty = this.uniqueForm.is_servicer_company_empty ? 1 : 0;
    params.is_order_check_show = this.uniqueForm.is_order_check_show ? 1 : 0;
    params.eorder_start_time = this.uniqueForm.eorder_start_time;
    params.eorder_end_time = this.uniqueForm.eorder_end_time;
    params.is_serforcus_complete_create_eorder = this.uniqueForm.is_serforcus_complete_create_eorder ? 1 : 0;
    params.is_eorder_invite_sign = this.uniqueForm.is_eorder_invite_sign ? 1 : 0;
    this.saveCopanySet(params);
  }
  // 保存支付设置
  private savePaySetBtn() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.pay_qr = this.uniqueForm.pay_qr.join(',');
    this.saveCopanySet(params);
  }
  // 保存支付设置
  private saveGNSetBtn() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.message = this.uniqueForm.message ? 1 : 0;
    params.video = this.uniqueForm.video ? 1 : 0;
    this.saveCopanySet(params);
  }
  // 保存企业微信设置
  private saveQYWXSet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.wx_servicer_logo = this.uniqueForm.wx_servicer_logo;
    params.wx_servicer_name = this.uniqueForm.wx_servicer_name;
    params.is_sync_qywxdept_upatename = this.uniqueForm.is_sync_qywxdept_upatename ? 1 : 0;
    params.is_sync_qywxapp_subscrible = this.uniqueForm.is_sync_qywxapp_subscrible ? 1 : 0;
    this.saveCopanySet(params);
  }
  private handleAppLogo(res:any) {
    this.uniqueForm.logo = res.key;
  }
  private handleGZHCode(res:any) {
    this.wechatForm.wx_qr_img = res.key;
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then(res => {
      let k = makeKey(this.qiniuBean.prekey);
      this.qiniuBean.key = k;
      this.qiniuBean.token = this.qiniuBean.uptoken;
    });
  }

  private payCodeHandle(res:any) {
    this.uniqueForm.pay_qr.push(res.key);
  }
  private imgLargeHandle(index: number) {
    let arr:any = [];
    for (let index = 0; index < this.uniqueForm.pay_qr.length; index++) {
      arr.push(this.qiniuBean.default_url + this.uniqueForm.pay_qr[index]);
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private imgLargeHandle1(index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [this.wxGZHImg, this.wxGZHImg2],
      initNum: 0
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private imgLargeHandle2(index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [this.wxGZHImg, this.wxGZHImg2],
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  // private largeHandle(value: any, index: number) {
  //   // let arr:any = [];
  //   // for (let index = 0; index < this.uniqueForm.pay_qr.length; index++) {
  //   //   arr.push(this.qiniuBean.default_url + this.uniqueForm.pay_qr[index]);
  //   // }
  //   let enlargedData = {
  //     isShow: true,
  //     imgList: [value],
  //     initNum: index
  //   };
  //   this.$store.dispatch('toggleEnlarged', enlargedData);
  // }

  private deleteimg(index:any) {
    this.uniqueForm.pay_qr.splice(index, 1);
  }

  // 获取 自定义工单
  private getDiyEorder(type:number) {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.check = 1;
    getDiyEorder(pamars).then(res => {
      if (res.data) {
        let style = {
          label: res.data.eorder_name,
          value: res.data.id
        };
        this.eorderStyleList.push(style);
        if (type === parseInt(res.data.id)) {
          // this.uniqueForm.eorder_style = style;
          this.uniqueForm.eorder_style = res.data.id
        }
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private copyNameHandle() {
    (this.$refs.onlyId as any).select(); // 选择input元素
    document.execCommand("Copy"); // 执行复制命令
  }
  private showPreviewHandle() {
    this.showPreview = !this.showPreview
  }
  private showPreviewOfficialHandle() {
    this.showPreviewOfficial = !this.showPreviewOfficial
  }
  private showPreviewWechatFollowHandle() {
    this.showPreviewOfficialFollow = !this.showPreviewOfficialFollow
  }
  private tabClick(tab: any, event:any) {
    if (tab.name !== 'APP') {
      this.showPreview = false
    }
    if (tab.name !== 'official') {
      this.showPreviewOfficial = false;
      this.showPreviewOfficialFollow = false;
    }
  }
  private weChatTabClick(tab: any) {
    if (tab.name === 'follow') {
      this.showPreviewOfficial = false
    }
    if (tab.name === 'push') {
      this.showPreviewOfficialFollow = false
    }
  }
  private form: object = {}; // 上传到七牛的token
  private defaultUrl: string = '';
  private beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey((UserModule.getQiniuToken as any).prekey);
      this.defaultUrl = (UserModule.getQiniuToken as any).default_url;
      this.form = {
        key: k,
        token: (UserModule.getQiniuToken as any).uptoken,
        domain: (UserModule.getQiniuToken as any).domain
      };
    });
  }
  private companyLogoUploadSuccess(res:any) {
    this.companyForm.logo = res.key
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
